import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
var DuelTabs = function DuelTabs() {
  return import('@/components/organisms/DuelTabs');
};
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var ArenaOverviewCard = function ArenaOverviewCard() {
  return import('@/components/organisms/ArenaOverviewCard');
};
var ExternalLink = function ExternalLink() {
  return import('@/components/atoms/ExternalLink');
};
var CreateArenaModal = function CreateArenaModal() {
  return import('@/components/organisms/CreateArenaModal');
};
var CreateLobby = function CreateLobby() {
  return import('@/components/molecules/CreateLobby');
};
var JoinArenaModal = function JoinArenaModal() {
  return import('@/components/organisms/JoinArenaModal');
};
var LoadingSpinner = function LoadingSpinner() {
  return import('@/components/atoms/LoadingSpinner');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
import Nl2br from 'vue-nl2br';
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
export default {
  components: {
    DuelTabs: DuelTabs,
    PageHeader: PageHeader,
    ArenaOverviewCard: ArenaOverviewCard,
    CreateArenaModal: CreateArenaModal,
    CreateLobby: CreateLobby,
    LoadingSpinner: LoadingSpinner,
    JoinArenaModal: JoinArenaModal,
    ExternalLink: ExternalLink,
    PageTitle: PageTitle,
    Nl2br: Nl2br,
    Modal: Modal
  },
  data: function data() {
    return {
      passwordInput: '',
      showError: false,
      foundArena: null,
      finishedArenas: [],
      publicArenas: [],
      privateArenas: [],
      publicAllArenas: [],
      showCreateArenaModal: false,
      isLoading: false,
      isLoadingHistory: true,
      isLoadingFinishedArenas: true,
      isLoadingPublicArenas: true,
      confirmJoinModalShown: false,
      shownCategory: 0,
      arenaToJoin: {},
      joinLimitData: [],
      joinAttributeLimitData: [],
      involvedArenas: [],
      participatedArenas: [],
      ownerHistoryArenas: [],
      displayedHistory: [],
      allHistories: [],
      selectedHistoryCategory: 0,
      publicArenasToShow: 20,
      finishedArenasToShow: 20,
      historyArenaCount: 20,
      isLoadingMoreArenas: false,
      updateArenasInterval: 0,
      nineDeck: {},
      joinPublicBtn: true,
      historyAllBtn: true,
      historyJoinBtn: false,
      historyHostBtn: false,
      invitationFailedModalShown: false,
      maxArenasCount: 0,
      activePage: 1,
      maxPage: 0
    };
  },
  computed: {
    me: function me() {
      return useUserStore().me;
    },
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    getInputClass: function getInputClass() {
      return {
        'arena__search__input-wrapper--error': this.showError && !this.foundArena,
        'arena__search__input-wrapper--success': this.foundArena
      };
    },
    queryPassword: function queryPassword() {
      return this.$route.query.pw || '';
    },
    user: function user() {
      return this.me || [];
    },
    arenaAcademyLink: function arenaAcademyLink() {
      if (this.$i18n.locale === 'ja') return 'https://my-crypto-heroes.gitbook.io/academy/battle/arena';
      return 'https://mycryptoheroes.gitbook.io/academy/game-modes/arena';
    },
    hasNineDeckReady: function hasNineDeckReady() {
      return !!Object.keys(this.nineDeck).length;
    },
    myPrivateArenas: function myPrivateArenas() {
      return this.involvedArenas.filter(function (arena) {
        return !arena.isPublic;
      });
    },
    navigation: function navigation() {
      return [this.$t('playerMatch.navigation.join'), this.$t('playerMatch.navigation.createLobby'), this.$t('playerMatch.navigation.history')];
    },
    isActivePublicBtn: function isActivePublicBtn() {
      return this.joinPublicBtn;
    },
    isJoinShown: function isJoinShown() {
      return this.shownCategory === 0;
    },
    isActiveAllBtn: function isActiveAllBtn() {
      return this.historyAllBtn;
    },
    isActiveJoinBtn: function isActiveJoinBtn() {
      return this.historyJoinBtn;
    },
    isActiveHostBtn: function isActiveHostBtn() {
      return this.historyHostBtn;
    },
    isHistoryShown: function isHistoryShown() {
      return this.shownCategory === 2;
    },
    isCreateLobbyShown: function isCreateLobbyShown() {
      return this.shownCategory === 1;
    },
    currentFoundArena: function currentFoundArena() {
      return this.foundArena;
    },
    showHostedArenas: function showHostedArenas() {
      return this.selectedHistoryCategory === 1;
    },
    arenaInfos: function arenaInfos() {
      switch (this.shownCategory) {
        case 0:
          return {
            arenas: this.publicArenas,
            isLoadingArenas: this.isLoadingPublicArenas,
            hasNoArenas: !this.isLoadingPublicArenas && !this.publicArenas.length,
            shownArenaCount: this.publicArenasToShow
          };
        case 1:
          return {};
        case 2:
          return {
            arenas: this.getHistoriesArenas(),
            isLoadingArenas: this.getHistoriesIsLoadingArenas(),
            hasNoArenas: this.getHistoriesHasNoArenas(),
            shownArenaCount: this.getHistoriesArenaCount()
          };
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this.getPublicArenas(0, _this.publicArenasToShow + 1);
          case 2:
            _this.isLoadingPublicArenas = false;
            _context2.next = 5;
            return _this.getFinishedArenas(0, _this.publicArenasToShow + 1);
          case 5:
            _this.isLoadingFinishedArenas = false;
            _context2.next = 8;
            return _this.getMyParticipatedArenas();
          case 8:
            _context2.next = 10;
            return _this.getMyOwnerHistories();
          case 10:
            _context2.next = 12;
            return _this.getInvolvedArenas();
          case 12:
            _context2.next = 14;
            return _this.autoQueryWithPassword();
          case 14:
            _context2.next = 16;
            return _this.getMaxArenasCount();
          case 16:
            _this.updateArenasInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this.updatePublicArenas();
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })), 30000);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.updateArenasInterval);
  },
  methods: {
    handleInput: function handleInput(e) {
      if (e.key === 'Enter') {
        this.searchArena();
      } else {
        this.showError = false;
      }
    },
    onSuccessfulCreate: function onSuccessfulCreate(password) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var newArena;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this2.$arenaService.getArenaInfoByPassword(password);
            case 2:
              newArena = _context3.sent;
              _this2.showCreateArenaModal = false;
              return _context3.abrupt("return", _this2.$router.push(_this2.localePath({
                name: "duel-arena-arenaId",
                params: {
                  arenaId: newArena.arenaId
                }
              })));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    searchArena: function searchArena() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var foundArena;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this3.foundArena = null;
              _this3.isLoading = true;
              _context4.prev = 2;
              _context4.next = 5;
              return _this3.$arenaService.getArenaInfoByPassword(_this3.passwordInput);
            case 5:
              foundArena = _context4.sent;
              _this3.$toast.success(_this3.$t('arena.arenaFound'));
              _this3.foundArena = foundArena;
              useUserStore().fetchUser(foundArena.ownerId);
              _context4.next = 16;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](2);
              _this3.showError = true;
              console.log(_context4.t0);
              _this3.$toast.error(_this3.$t('arena.arenaNotFound'));
            case 16:
              _context4.prev = 16;
              _this3.isLoading = false;
              return _context4.finish(16);
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 11, 16, 19]]);
      }))();
    },
    clearSearch: function clearSearch() {
      this.passwordInput = '';
      this.showError = false;
      return;
    },
    getMyOwnerHistories: function getMyOwnerHistories() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this4.$arenaService.getOwnerHistories(_this4.user.uid);
            case 2:
              res = _context5.sent;
              _this4.ownerHistoryArenas = res.historiesList;
              return _context5.abrupt("return", _this4.ownerHistoryArenas);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getMyParticipatedArenas: function getMyParticipatedArenas() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this5.$arenaService.getParticipantHistories(_this5.user.uid);
            case 2:
              res = _context6.sent;
              _this5.participatedArenas = res.historiesList;
              return _context6.abrupt("return", _this5.participatedArenas);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    joinArena: function joinArena(password) {
      var _arguments = arguments,
        _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var allowForward, options, teamToJoin, selectedHeroIds, templates, selectedTemplate;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              allowForward = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              options = _arguments.length > 2 ? _arguments[2] : undefined;
              teamToJoin = options.teamToJoin, selectedHeroIds = options.selectedHeroIds, templates = options.templates, selectedTemplate = options.selectedTemplate;
              _context7.prev = 3;
              _context7.next = 6;
              return _this6.$arenaService.joinArenaV2(password, teamToJoin, selectedHeroIds, selectedTemplate);
            case 6:
              _this6.$toast.success(_this6.$t('playerMatch.successfullyJoined'));
              allowForward && _this6.$router.push(_this6.localePath({
                name: "duel-arena-arenaId",
                params: {
                  arenaId: _this6.arenaToJoin.arenaId
                }
              }));
              _context7.next = 13;
              break;
            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](3);
              _this6.$toast.error(_context7.t0.message || 'Could not join Arena.');
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[3, 10]]);
      }))();
    },
    // async getFinishedArenas(offset, count) {
    //   const finishedArenas = await this.$arenaService.getCompletedArenaIds(
    //     offset,
    //     count
    //   )
    //   const finishedArenaDetails = await Promise.all(
    //     finishedArenas.arenaIdsList.map(arenaId =>
    //       this.$arenaService.getArenaInfo(arenaId)
    //     )
    //   )
    //   const hostUids = finishedArenaDetails.map(arena => arena.ownerId)
    //   useUserStore().fetchUsers(hostUids)
    //   return this.finishedArenas.push(...finishedArenaDetails)
    // },
    getPublicArenas: function getPublicArenas(offset, count) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this7$publicArenas;
        var publicArenas, publicArenaDetails, hostUids;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this7.$arenaService.getOngoingPublicArenaPasswords(offset, count);
            case 2:
              publicArenas = _context8.sent;
              _context8.next = 5;
              return Promise.all(publicArenas.passwordsList.map(function (arenaPw) {
                return _this7.$arenaService.getArenaInfoByPassword(arenaPw);
              }));
            case 5:
              publicArenaDetails = _context8.sent;
              hostUids = publicArenaDetails.map(function (arena) {
                return arena.ownerId;
              });
              useUserStore().fetchUsers(hostUids);
              return _context8.abrupt("return", (_this7$publicArenas = _this7.publicArenas).push.apply(_this7$publicArenas, _toConsumableArray(publicArenaDetails)));
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getInvolvedArenas: function getInvolvedArenas() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var joinedArenas, hostedArenas, involvedArenas, arenaDetails, hostUids;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              // 1. step: get all joined
              joinedArenas = _this8.participatedArenas.filter(function (arena) {
                return arena.status < 3;
              }) || []; // 2. step: get all hosted
              hostedArenas = _this8.ownerHistoryArenas.filter(function (arena) {
                return arena.status < 3;
              }) || []; // 2. step: get info and push to state
              involvedArenas = _this8.$util.uniq([].concat(_toConsumableArray(joinedArenas.map(function (arena) {
                return arena.arenaId;
              })), _toConsumableArray(hostedArenas.map(function (arena) {
                return arena.arenaId;
              }))));
              if (!involvedArenas.length) {
                _context9.next = 10;
                break;
              }
              _context9.next = 6;
              return Promise.all(involvedArenas.map(function (arenaId) {
                return _this8.$arenaService.getArenaInfo(arenaId);
              }));
            case 6:
              arenaDetails = _context9.sent;
              hostUids = arenaDetails.map(function (arena) {
                return arena.ownerId;
              });
              useUserStore().fetchUsers(hostUids);
              return _context9.abrupt("return", _this8.involvedArenas = arenaDetails);
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    getArenasById: function getArenasById(arenaArray) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var detailedArenas;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return Promise.all(arenaArray.map(function (arena) {
                return _this9.$arenaService.getArenaInfo(arena.arenaId).catch(function () {
                  return undefined;
                });
              }));
            case 2:
              detailedArenas = _context10.sent;
              return _context10.abrupt("return", detailedArenas.filter(function (arena) {
                return arena != undefined;
              }));
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    switchHistoryCategory: function switchHistoryCategory(newCategory) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this10.activePage = 1;
              if (!_this10.isFetchingHistory) {
                _context11.next = 3;
                break;
              }
              return _context11.abrupt("return");
            case 3:
              if (!(_this10.selectedHistoryCategory === newCategory)) {
                _context11.next = 5;
                break;
              }
              return _context11.abrupt("return");
            case 5:
              _this10.selectedHistoryCategory = newCategory;
              _context11.next = 8;
              return _this10.fetchHistory();
            case 8:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    fetchHistory: function fetchHistory() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var offset;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this11.isLoadingHistory = true;
              _this11.allHistories = [];
              if (!(_this11.selectedHistoryCategory === 0)) {
                _context12.next = 14;
                break;
              }
              if (!(_this11.activePage == 1)) {
                _context12.next = 8;
                break;
              }
              _context12.next = 6;
              return _this11.getFinishedArenas(0, 20);
            case 6:
              _context12.next = 11;
              break;
            case 8:
              offset = (_this11.activePage - 1) * 20;
              _context12.next = 11;
              return _this11.getFinishedArenas(offset++, 20);
            case 11:
              _this11.allHistories = _this11.finishedArenas;
              _context12.next = 25;
              break;
            case 14:
              if (!(_this11.selectedHistoryCategory === 2)) {
                _context12.next = 20;
                break;
              }
              _context12.next = 17;
              return _this11.getArenasById(_this11.ownerHistoryArenas);
            case 17:
              _context12.t0 = _context12.sent;
              _context12.next = 23;
              break;
            case 20:
              _context12.next = 22;
              return _this11.getArenasById(_this11.participatedArenas);
            case 22:
              _context12.t0 = _context12.sent;
            case 23:
              _this11.allHistories = _context12.t0;
              _this11.getDispHistories();
            case 25:
              _context12.next = 27;
              return _this11.getMaxArenasCount();
            case 27:
              _this11.isLoadingHistory = false;
            case 28:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    canJoin: function canJoin(status) {
      return status === 1 || status === 3;
    },
    autoQueryWithPassword: function autoQueryWithPassword() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!_this12.queryPassword) {
                _context13.next = 15;
                break;
              }
              _this12.passwordInput = _this12.queryPassword;
              _context13.next = 4;
              return _this12.searchArena();
            case 4:
              if (!(_this12.foundArena != null)) {
                _context13.next = 13;
                break;
              }
              if (!_this12.didJoinArena(_this12.foundArena.arenaId)) {
                _context13.next = 9;
                break;
              }
              return _context13.abrupt("return", _this12.$router.push(_this12.localePath({
                name: "duel-arena-arenaId",
                params: {
                  arenaId: _this12.foundArena.arenaId
                }
              })));
            case 9:
              _this12.joinPublicBtn = false;
              _this12.openJoinModal(_this12.foundArena);
            case 11:
              _context13.next = 14;
              break;
            case 13:
              _this12.invitationFailedModalShown = true;
            case 14:
              _this12.$router.push(_this12.localePath('duel-arena'));
            case 15:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    updateInvolvedArenas: function updateInvolvedArenas() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return Promise.all(_this13.involvedArenas.map(function (arena) {
                return _this13.$arenaService.getArenaInfo(arena.arenaId);
              }));
            case 2:
              _this13.involvedArenas = _context14.sent;
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    updateFoundArena: function updateFoundArena() {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _this14.$arenaService.getArenaInfo(_this14.foundArena.arenaId);
            case 2:
              _this14.foundArena = _context15.sent;
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    updatePublicArenas: function updatePublicArenas() {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var arenaPws;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              arenaPws = _this15.publicArenas.filter(function (arena) {
                return arena.battledAt > Math.floor(Date.now() / 1000) || _this15.isArenaOngoing(arena);
              }).map(function (arena) {
                return arena.password;
              });
              _context16.next = 3;
              return Promise.all(arenaPws.map(function (arenaPw) {
                return _this15.$arenaService.getArenaInfoByPassword(arenaPw);
              }));
            case 3:
              _this15.publicArenas = _context16.sent;
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    loadMoreArenas: function loadMoreArenas() {
      var _arguments2 = arguments,
        _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var number, publicOffset, finishedOffset;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              number = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : 20;
              _this16.isLoadingMoreArenas = true;
              _context17.t0 = _this16.shownCategory;
              _context17.next = _context17.t0 === 0 ? 5 : _context17.t0 === 1 ? 9 : _context17.t0 === 2 ? 10 : 18;
              break;
            case 5:
              publicOffset = _this16.publicArenas.length;
              _context17.next = 8;
              return _this16.getPublicArenas(publicOffset, number);
            case 8:
              _this16.publicArenasToShow += number;
            case 9:
              return _context17.abrupt("return");
            case 10:
              if (!(_this16.selectedHistoryCategory == 0)) {
                _context17.next = 17;
                break;
              }
              finishedOffset = _this16.finishedArenas.length;
              _context17.next = 14;
              return _this16.getFinishedArenas(finishedOffset, number);
            case 14:
              _this16.finishedArenasToShow += number;
              _context17.next = 18;
              break;
            case 17:
              _this16.historyArenaCount += number;
            case 18:
              _this16.isLoadingMoreArenas = false;
            case 19:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    openJoinModal: function openJoinModal(arenaToJoin) {
      var _this17 = this;
      if (this.isArenaDone(arenaToJoin) || this.didHostArena(arenaToJoin.arenaId) || this.didJoinArena(arenaToJoin.arenaId)) {
        return this.$router.push(this.localePath({
          name: "duel-arena-arenaId",
          params: {
            arenaId: arenaToJoin.arenaId
          }
        }));
      } else {
        this.arenaToJoin = arenaToJoin;
        this.joinLimitData = [];
        var upperLimit = this.$util.clone(this.arenaToJoin.heroRarityUpperLimitMap);
        upperLimit.sort(function (p, c) {
          if (p[0] < c[0]) return -1;
          if (p[0] > c[0]) return 1;
          return 0;
        });
        upperLimit.forEach(function (x) {
          if (x[1] != 0 && x[1] != 5) {
            var pushData = {
              rarity: x[0],
              limit: x[1]
            };
            _this17.joinLimitData.push(pushData);
          }
        });
        this.joinAttributeLimitData = [];
        var attributeLimit = this.$util.clone(this.arenaToJoin.heroAttributeLimitMap);
        var isLimit = false;
        var attributeLimitData = [];
        attributeLimit.forEach(function (x) {
          if (x[1] != 0) {
            var pushData = {
              attr: x[0],
              limit: x[1]
            };
            if (x[1] != 5) isLimit = true;
            attributeLimitData.push(pushData);
          } else {
            isLimit = true;
          }
        });
        if (isLimit) this.joinAttributeLimitData = attributeLimitData;
        this.confirmJoinModalShown = true;
      }
    },
    closeJoinModal: function closeJoinModal() {
      this.arenaToJoin = {};
      this.joinLimitData = [];
      this.joinAttributeLimitData = [];
      this.confirmJoinModalShown = false;
    },
    didJoinArena: function didJoinArena(arenaId) {
      return !!this.participatedArenas.find(function (arena) {
        return arena.arenaId === arenaId && arena.status < 4;
      });
    },
    didHostArena: function didHostArena(arenaId) {
      return !!this.ownerHistoryArenas.find(function (arena) {
        return arena.arenaId === arenaId;
      });
    },
    updateArenas: function updateArenas() {
      switch (this.shownCategory) {
        case 0:
          return this.updatePublicArenas();
        case 1:
          return;
        // todo: update participated arenas
        case 2:
          return;
        // nothing to update
        case 3:
          return;
        // todo: update participated and hosted arenas
      }
    },
    switchCategory: function switchCategory(newCategory) {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this18.shownCategory = newCategory;
              if (!(_this18.shownCategory == 2)) {
                _context18.next = 4;
                break;
              }
              _context18.next = 4;
              return _this18.fetchHistory();
            case 4:
              _this18.activePage = 1;
              _context18.next = 7;
              return _this18.getMaxArenasCount();
            case 7:
              return _context18.abrupt("return");
            case 8:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    isArenaCancelled: function isArenaCancelled(arena) {
      return arena.status === 4;
    },
    isArenaOngoing: function isArenaOngoing(arena) {
      return arena.status === 6;
    },
    isArenaDone: function isArenaDone(arena) {
      return arena.status > 2;
    },
    onClickJoinPublicBtn: function onClickJoinPublicBtn() {
      if (this.joinPublicBtn === false) {
        this.joinPublicBtn = !this.joinPublicBtn;
        this.activePage = 1;
      }
    },
    onClickJoinPrivateBtn: function onClickJoinPrivateBtn() {
      if (this.joinPublicBtn === true) {
        this.joinPublicBtn = !this.joinPublicBtn;
        this.activePage = 1;
      }
    },
    onClickHistoryAllBtn: function onClickHistoryAllBtn() {
      if (this.historyAllBtn == false) {
        this.historyAllBtn = true;
        this.historyJoinBtn = false;
        this.historyHostBtn = false;
        this.switchHistoryCategory(0);
      }
    },
    onClickHistoryParticipatedBtn: function onClickHistoryParticipatedBtn() {
      if (this.historyJoinBtn == false) {
        this.historyAllBtn = false;
        this.historyJoinBtn = true;
        this.historyHostBtn = false;
        this.switchHistoryCategory(1);
      }
    },
    onClickHistoryHostedBtn: function onClickHistoryHostedBtn() {
      if (this.historyHostBtn == false) {
        this.historyAllBtn = false;
        this.historyJoinBtn = false;
        this.historyHostBtn = true;
        this.switchHistoryCategory(2);
      }
    },
    canEntryModalFinish: function canEntryModalFinish() {
      return !!this.selectedHeroIds.length || this.selectedTemplate !== null;
    },
    onClickPageInitial: function onClickPageInitial() {
      var _this19 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(_this19.activePage != 1)) {
                _context19.next = 4;
                break;
              }
              _this19.activePage = 1;
              _context19.next = 4;
              return _this19.fetchHistory();
            case 4:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    onClickPageBack: function onClickPageBack() {
      var _this20 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!(_this20.activePage != 1)) {
                _context20.next = 4;
                break;
              }
              _this20.activePage--;
              _context20.next = 4;
              return _this20.fetchHistory();
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    onClickPageNum: function onClickPageNum(index) {
      var _this21 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _this21.activePage = index;
              _context21.next = 3;
              return _this21.fetchHistory();
            case 3:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    },
    onClickPageNext: function onClickPageNext() {
      var _this22 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!(_this22.activePage != _this22.maxPage)) {
                _context22.next = 4;
                break;
              }
              _this22.activePage++;
              _context22.next = 4;
              return _this22.fetchHistory();
            case 4:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    onClickPageEnd: function onClickPageEnd() {
      var _this23 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (!(_this23.activePage != _this23.maxPage)) {
                _context23.next = 4;
                break;
              }
              _this23.activePage = _this23.maxPage;
              _context23.next = 4;
              return _this23.fetchHistory();
            case 4:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    getDisplayCount: function getDisplayCount() {
      if (this.activePage != this.maxPage) {
        return (this.activePage - 1) * 20 + 20;
      } else {
        if (this.shownCategory == 0) {
          return (this.activePage - 1) * 20 + this.publicArenas.length;
        } else {
          if (this.selectedHistoryCategory == 0) {
            return (this.activePage - 1) * 20 + this.finishedArenas.length;
          } else {
            return (this.activePage - 1) * 20 + this.displayedHistory.length;
          }
        }
      }
    },
    getPageCount: function getPageCount() {
      var page = Math.floor(this.maxArenasCount / 20);
      if (Math.floor(this.maxArenasCount % 20)) page++;
      this.maxPage = page;
      if (page <= 5) return page;
      if (this.activePage >= 4) {
        var dispMinPage = this.activePage - 2;
        if (dispMinPage + 4 >= this.maxPage) {
          dispMinPage = this.maxPage - 4;
        }
        var pageArray = [];
        for (var i = dispMinPage; i <= dispMinPage + 4; i++) {
          pageArray.push(i);
        }
        return pageArray;
      }
      return 5;
    },
    getFinishedArenas: function getFinishedArenas(offset, count) {
      var _this24 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var finishedArenas, finishedArenaDetails, hostUids;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return _this24.$arenaService.getCompletedArenaIds(offset, count);
            case 2:
              finishedArenas = _context24.sent;
              _context24.next = 5;
              return Promise.all(finishedArenas.arenaIdsList.map(function (arenaId) {
                return _this24.$arenaService.getArenaInfo(arenaId);
              }));
            case 5:
              finishedArenaDetails = _context24.sent;
              hostUids = finishedArenaDetails.map(function (arena) {
                return arena.ownerId;
              });
              useUserStore().fetchUsers(hostUids);
              return _context24.abrupt("return", _this24.finishedArenas = finishedArenaDetails);
            case 9:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }))();
    },
    getPublicArenas2: function getPublicArenas2(offset, count) {
      var _this25 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var publicArenas, publicArenaDetails, hostUids;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return _this25.$arenaService.getOrganisingPublicArenaPasswords(offset, count);
            case 2:
              publicArenas = _context25.sent;
              _context25.next = 5;
              return Promise.all(publicArenas.passwordsList.map(function (arenaPw) {
                return _this25.$arenaService.getArenaInfoByPassword(arenaPw);
              }));
            case 5:
              publicArenaDetails = _context25.sent;
              hostUids = publicArenaDetails.map(function (arena) {
                return arena.ownerId;
              });
              useUserStore().fetchUsers(hostUids);
              return _context25.abrupt("return", _this25.publicArenas = publicArenaDetails);
            case 9:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    getMaxArenasCount: function getMaxArenasCount() {
      var _this26 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var arenas;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!(_this26.selectedHistoryCategory == 0)) {
                _context26.next = 7;
                break;
              }
              _context26.next = 3;
              return _this26.$arenaService.getCompletedArenaIds(0, 180);
            case 3:
              arenas = _context26.sent;
              return _context26.abrupt("return", _this26.maxArenasCount = arenas.arenaIdsList.length);
            case 7:
              return _context26.abrupt("return", _this26.maxArenasCount = _this26.allHistories.length);
            case 8:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      }))();
    },
    getDispHistories: function getDispHistories() {
      var startNum = 0;
      var endNum = 20;
      this.displayedHistory = [];
      if (this.activePage != 1) {
        var offset = (this.activePage - 1) * 20;
        startNum = offset++;
        endNum = startNum + 20;
      }
      if (endNum > this.allHistories.length) endNum = this.allHistories.length;
      for (var i = startNum; i < endNum; i++) {
        this.displayedHistory.push(this.allHistories[i]);
      }
      return this.displayedHistory;
    },
    getHistoriesArenas: function getHistoriesArenas() {
      if (this.selectedHistoryCategory == 0) {
        return this.finishedArenas;
      } else {
        return this.displayedHistory;
      }
    },
    getHistoriesIsLoadingArenas: function getHistoriesIsLoadingArenas() {
      if (this.selectedHistoryCategory == 0) {
        return this.isLoadingFinishedArenas;
      } else {
        return this.isLoadingHistory;
      }
    },
    getHistoriesHasNoArenas: function getHistoriesHasNoArenas() {
      if (this.selectedHistoryCategory == 0) {
        return !this.isLoadingFinishedArenas && !this.finishedArenas.length;
      } else {
        return !this.isLoadingHistory && !this.displayedHistory.length;
      }
    },
    getHistoriesArenaCount: function getHistoriesArenaCount() {
      if (this.selectedHistoryCategory == 0) {
        return this.finishedArenasToShow;
      } else {
        return this.historyArenaCount;
      }
    }
  }
};